var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('a-config-provider',{attrs:{"locale":_vm.configProviderLocale}},[_c('div',{directives:[{name:"show",rawName:"v-show",value:(_vm.localeLoading),expression:"localeLoading"}],attrs:{"id":"app"}},[_c('router-view')],1)])}
var staticRenderFns = []

export { render, staticRenderFns }